module.exports = {
  OFFER_STATUS_OK: 'ok',
  OFFER_STATUS_STALED: 'staled',
  OFFER_STATUS_EXPIRED: 'expired',
};
